import { DropDown, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Stack, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { useChangeTracker } from '../../context/change-tracker';
import * as Styled from './styles';
import * as SX from './sx';
import type { ManagerOption, AccountManagerProps as Props } from './types';

const options: ManagerOption[] = [
  {
    key: 'Neda@ai-bees.io',
    value: 'Neda@ai-bees.io',
    label: 'Neda@ai-bees.io',
    avatar: '/assets/images/avatar1.png',
  },
  {
    key: 'Brian@ai-bees.io',
    value: 'Brian@ai-bees.io',
    label: 'Brian@ai-bees.io',
    avatar: '/assets/images/avatar2.png',
  },
  {
    key: 'Setayesh@ai-bees.io',
    value: 'Setayesh@ai-bees.io',
    label: 'Setayesh@ai-bees.io',
    avatar: '/assets/images/avatar1.png',
  },
];

export const AccountManager = memo(({ className }: Props) => {
  const [selected, setSelected] = useState<string | undefined>(undefined);
  const { markDirty } = useChangeTracker();

  const handleChange = (v: string) => {
    setSelected(v);
    markDirty();
  };

  return (
    <Styled.Wrapper
      className={classnames('AccountManager', className)}
      sx={SX.root}
      gap={0.5}
    >
      <Typography variant="body4" color="grey.500">
        Account Manager
      </Typography>
      <DropDown
        size="large"
        fullWidth
        placeholder="Select account manager"
        options={options}
        value={selected ?? ''}
        onChange={(v) => handleChange(v as string)}
        renderItem={(label, option, isSelected) => {
          const manager = option as ManagerOption;

          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Stack direction="row" alignItems="center" gap={1}>
                <Avatar
                  src={manager.avatar}
                  alt={label as string}
                  variant="rounded"
                  size={32}
                />
                <Typography variant="body4" fontWeight={500} color="grey.600">
                  {label}
                </Typography>
              </Stack>
              {isSelected && <Icon name="check" color="primary.400" />}
            </Stack>
          );
        }}
      />
    </Styled.Wrapper>
  );
});

AccountManager.displayName = 'AccountManager';
